<template>
  <div class="file-uploader" :id="id">
    <!-- <i class="icon-loading" v-if="showLoading" @click.prevent></i> -->
    <slot></slot>
  </div>
</template>
<script>
import $ from "@/scripts/jquery.Huploadify.js";
import {BASEURL} from '@/scripts/util.js';
import {bpoLoading,bpoHideLoading} from '@/scripts/bpo.js'
export default {
  name:'uploader',
  props:{
    imgSrc:{
      type:String,
      default:'',
    },
    url:{
      type:String,
      default: BASEURL+'/api/Upload/UploadImg',
      // default:'http://test.api.gongkongbpo.com/api/Upload/UploadImg',
    },
    id:{
      type:String,
      default:'uploadBtn',
    },
    accept:{
      type:String,
      default:'*.*',
    },
    buttonText:{
      type:String,
      default:'',
    },
    multi:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      files:[],
      showLoading:false,
    }
  },
  mounted() {
    this.upload();
  },
  methods: {
    upload(){
      var that=this;
      var layerIndex;
      $("#"+this.id).Huploadify({
          auto:true,
          fileTypeExts:that.accept,
          multi:that.multi,
          fileObjName:'Filedata',
          buttonText:that.buttonText,
          uploader:that.url,
          fileSizeLimit:1024*60,
          onUploadStart:function (file) {
            that.showLoading=true;
            layerIndex=bpoLoading();
          },
          onUploadSuccess:function(file,res){
            that.showLoading=false;
            var r=JSON.parse(res);
            if(r.Result==1){
              that.$emit('success',file,r.Data);
            }else{
              that.$toast(r.Message);
            }
            bpoHideLoading(layerIndex);
          },
          onUploadError:function(file,response){
            that.showLoading=false;
            that.$toast('上传失败！');
            that.$emit('error',file,response);
            bpoHideLoading(layerIndex);
          }
      })
    }
  },
}
</script>
<style lang="scss">
@import '@/style/Huploadify.scss';
.file-uploader{
  display: inline-block;
  position: relative;
  overflow: hidden;
  width:80px;
  height:80px;
  .icon-loading{
    border: 1px solid #ddd;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    width:100%;
    height: 100%;
    margin: 0;
  }
  .uploadify-button{
    position:absolute;
    left:0;
    top:0;
    z-index:2;
    width:100%;
    height:100%;
    margin:0;
    opacity:0;
  }
}
</style>